import { generate } from "shortid";
import { PAGE_THEMES } from "../../types";
import { ANXIETY_SCALE_LIST } from "@/config";

export const PREMIUM_ANXIETY_PAGES = {
  anxiety_profile_goals_info_page: {
    id: `anxiety_profile_goals_info_page-${generate()}`,
    type: "info_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: null,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.WARM,
    data: {
      title: "Help us understand your goals",
      description:
        "What is getting in the way of you living your best life? Tell us so we can personalize your treatment.",
      image: "illustrations/anxiety-profile",
      custom_back: null,
      default_progression: "anxiety_profile_fears_page",
      options: [],
    },
  },
  anxiety_profile_fears_page: {
    id: `anxiety_profile_fears_page-${generate()}`,
    type: "multi_pill_select_type",
    backwards_navigation_enabled: true,
    title: "My Triggers",
    module_name: "premium_anxiety",
    target_state: "anxiety_data",
    target_field: "choose_fears",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What is it about your phobia that actually scares you?",
      description: "Select all that apply",
      image: null,
      custom_back: null,
      default_progression: "anxiety_profile_comfortability_page",
      options: [],
    },
  },
  anxiety_profile_comfortability_page: {
    id: `anxiety_profile_comfortability_page-${generate()}`,
    type: "multi_select_type",
    backwards_navigation_enabled: true,
    title: "My Goals",
    module_name: "premium_anxiety",
    target_state: "anxiety_data",
    target_field: "choose_comforts",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "I want to be comfortable when...",
      description:
        "Select all the situations that make you feel anxious, that you want to do comfortably in the future.",
      image: null,
      custom_back: null,
      default_progression: "anxiety_profile_feeling_page",
      options: [],
    },
  },
  anxiety_profile_feeling_page: {
    id: `anxiety_profile_feeling_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "My Goals",
    module_name: "premium_anxiety",
    target_state: "anxiety_data",
    target_field: "choose_feeling",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "If you were in one of these situations now, how would you feel?",
      description: "Think of the situation that makes you most anxious",
      image: null,
      custom_back: null,
      default_progression: "anxiety_profile_comfortability_page",
      options: ANXIETY_SCALE_LIST.map((item) => ({
        ...item,
        to: "anxiety_profile_uncommon_info_page",
      })),
    },
  },
  anxiety_profile_uncommon_info_page: {
    id: `anxiety_profile_uncommon_info_page-${generate()}`,
    type: "info_type",
    backwards_navigation_enabled: true,
    title: "My Goals",
    module_name: "premium_anxiety",
    target_state: "anxiety_data",
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.COLD,
    data: {
      title: "It’s not uncommon to have these feelings",
      description:
        "oVRcome has over 120 exposure simulations. We’ll find the right ones to help you feel less anxious in these situations.",
      image: "illustrations/feelings",
      custom_back: null,
      default_progression: "celebrate_page",
      options: [],
    },
  },
};
